<template>
    <vue-final-modal
        name="alarm-modal"
        class="modal-alarm"
        @before-open="handlerBeforeOpen"
        @before-close="handlerBeforeClose"
        v-model="showModal"
    >
        <div class="container-alarm" v-if="showModal">
            <div class="wrap-title-alarm fs-0">
                <button class="btn-back" @click="$vfm.hide('alarm-modal')"></button>
                <div class="title-alarm">
                    알림
                </div>
                <button class="btn-setting ml-auto" @click="$router.push('/mypage/alarm')">알림 설정</button>
            </div>



                <alarm-list-component :alarmType="'alarm'"></alarm-list-component>

        </div>

    </vue-final-modal>
</template>
<script>
import EventBus from "@/utils/event-bus";
import AlarmListComponent from "@/components/alarm/AlarmListComponent.vue";

export default {
    name: "AlarmModal",
    mixins: [],
    components: {AlarmListComponent},
    props: {},
    data() {
        return {
            showModal: false,
            test:20,
            beforePath: '',
        };
    },
    beforeRouterEnter() {
    },
    created() {
    },
    mounted() {
    },
    beforeUnmount() {
    },
    destroyed() {
    },
    computed: {},
    methods: {
        backEvent() {
            this.$vfm.hide("alarm-modal");
        },

        handlerBeforeOpen() {
            this.beforePath = this.$route.fullPath;
            if (this.$route.fullPath != this.$route.path) {
                this.$router.replace(this.$route.path)
            }
            this.showModal = true;
        },
        handlerBeforeClose() {
            if (this.$route.fullPath != this.beforePath) {
                this.$router.replace(this.beforePath)
            }
            this.showModal = false;
        },
    },
    watch: {},
};
</script>

<style scoped></style>
